import { Component, Input, OnInit } from "@angular/core";
import { BsModalService, ModalOptions } from "ngx-bootstrap/modal";
import { MapImageOverlay } from "../../../core/models";
import { WaypointTableRow } from "../../../core/models/path-waypoint";

export type PathKmlViewerModalInitialState = {
  buildingId?: string;
  paths: { pathId: string; mapWaypointRows: WaypointTableRow[] }[];
  selectedPathIds: string[];
  overlaysByPathId?: Record<string, MapImageOverlay | undefined>;
};

@Component({
  selector: "modal-content",
  templateUrl: "./path-kml-viewer-modal.component.html",
  styleUrls: [
    "../../../shared/mapping/kml/kml-viewer/kml-viewer-modal.component.scss",
  ],
})
export class PathKmlViewerModal implements OnInit {
  static readonly ModalId = 20241210;

  static show(
    bsModalService: BsModalService,
    initialState: PathKmlViewerModalInitialState
  ) {
    const context: ModalOptions = {
      initialState,
      class: "kml-viewer-modal",
      id: PathKmlViewerModal.ModalId,
      animated: true,
      ignoreBackdropClick: true,
    };
    return bsModalService.show(PathKmlViewerModal, context);
  }

  @Input() paths: { pathId: string; mapWaypointRows: WaypointTableRow[] }[];
  @Input() selectedPathIds: string[] = [];
  @Input() overlaysByPathId: Record<string, MapImageOverlay | undefined> = {};

  buildingIds: string[] = [];

  constructor(private modalService: BsModalService) {}

  ngOnInit(): void {
    this.buildingIds = this.paths
      .map((p) => p.mapWaypointRows[0]?.buildingId)
      .filter((id, i, a) => a.indexOf(id) == i)
      .sort();
  }

  onCloseModal = () => {
    this.modalService.hide(PathKmlViewerModal.ModalId);
  };
}
